import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
import ReaderEdit from './reader-edit'
import ReaderList from './reader-list'
import ReaderAdd from './reader-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Reader = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.READER}
                        component={ReaderList}
                    />
                    <Route
                        exact
                        path={ROUTES.READER_EDIT}
                        component={ReaderEdit}
                    />
                    <Route
                        exact
                        path={ROUTES.READER_ADD}
                        component={ReaderAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Reader)



// WEBPACK FOOTER //
// ./src/pages/reader/index.js